import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const THEMES = [
  { id: 'light', label: 'Light', icon: Sun },
  { id: 'dark', label: 'Dark', icon: Moon },
  { id: 'system', label: 'System', icon: Monitor },
];

/** Light / Dark / System picker (Settings > Preferences); state lives in ThemeContext. */
function ThemeSwitcher() {
  const { mode, setMode } = useTheme();
  return (
    <div className="flex gap-2">
      {THEMES.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => setMode(id)}
          aria-pressed={mode === id}
          className={`px-4 py-2 rounded-md border transition flex items-center gap-2 ${
            mode === id
              ? 'bg-primary text-primary-foreground border-primary'
              : 'bg-card border-border hover:bg-muted'
          }`}
          data-testid={`theme-${id}`}
        >
          <Icon className="w-4 h-4" />
          {label}
        </button>
      ))}
    </div>
  );
}

export default ThemeSwitcher;
